// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"c3b42a02","787":"8a220983"}[chunkId] + ".chunk.js";
};